module.exports = __webpack_public_path__ + "static/media/narjess.d102c271.jpeg";